import { Drawer, Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import "./gridControls.scss";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import VisibilityIcon from '@mui/icons-material/Visibility';
import EmailIcon from "@material-ui/icons/Email";
import RefreshIcon from "@material-ui/icons/Refresh";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import TrendingFlatIcon from "@material-ui/icons/TrendingFlat";
import { connect } from "react-redux";

const GridActionItem = ({ key, items, miscState }) => {
  const [showSidePanel, setShowPanel] = useState(false);
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setShowPanel(open);
  };

  useEffect(() => {
    if (miscState.selectedClose.isClosed) {
      setShowPanel(false);
    }
  }, [miscState.selectedClose]);

  const handleDrawerClose = (colData) => {
    const { onCloseSidePanel = null } = colData || {};
    if (onCloseSidePanel) {
      onCloseSidePanel();
    } else {
      toggleDrawer(false);
      setShowPanel(false);
    }
  };

  const getActionControls = (col) => {
    switch (col.name) {
      case "view":
        return(
          <div className="grid-action-item-icon-container" key={"right"}>
            <VisibilityIcon
              className="grid-action-item-icon"
              onClick={col.action}
            />            
          </div>
        );
      case "edit":
        return (
          <div className="grid-action-item-icon-container" key={"right"}>
            <EditIcon
              className="grid-action-item-icon"
              onClick={col.action}
            />
          </div>
        );
      case "delete":
        return (
          <div className="grid-action-item-icon-container">
            <DeleteIcon
              className="grid-action-item-icon"
              onClick={col.action}
            />
          </div>
        );
        case "email":
        return (
          <div className="grid-action-item-icon-container" key={"right"}>
            <EmailIcon
              className="grid-action-item-icon"
              onClick={col.action}
            />
          </div>
        );
        case "renewlicense":
        return (
          <div className="grid-action-item-icon-container" key={"right"}>
            <RefreshIcon
              className="grid-action-item-icon"
              onClick={col.action}
            />
          </div>
        );
      case "convertLicense":
        return (
          <div className="grid-action-item-icon-container" key={"right"}>
            <TrendingFlatIcon
              className="grid-action-item-icon"
              onClick={col.action}
            />
          </div>
        );
        case "slide":
        return (
          <div className="grid-action-item-icon-container">
            <DeleteIcon
              className="grid-action-item-icon"
              onClick={col.action}
            />
          </div>
        );
      case "more-options":
        return (
          <div className="grid-action-item-more-icon-container">
            <MoreHorizIcon
              className="grid-action-item-more-icon"
              onClick={col.action}
            />
          </div>
        );
      // Admin module -> reports menu -> download icon implementation
        case "download":
          return (
            <div className="grid-action-item-icon-container" key={"right"}>
              <FileDownloadOutlinedIcon
                className="grid-action-item-icon"
                onClick={col.action}
              />
            </div>
          );  
      default:
        break;
    }
  };

  return (
    <Grid
      container
      xs={12}
      key={key}
      spacing={0}
      className="grid-action-container"
    >
      {items.map((i) => {
        return (
          <Grid item md={12 / items.length} className="grid-action-item">
            {getActionControls(i)}
          </Grid>
        );
      })}
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  modelState: state.model,
  miscState: state.misc,
});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(GridActionItem);
